export const getStripeSetupIntentToken = 'getStripeSetupIntentToken';
export const getSelectedProduct = 'getSelectedProduct';
export const getIsAnnual = 'getIsAnnual';
